import "./styles.less";

import { Col, Modal, Row } from "antd";

import { FullScreen } from "../../FullScreen/web";
import React from "react";
import { useTheme } from "../../../Styles/ThemeHook";

export const ModalSimilars = ({
	visible,
	onCancel,
	width = 420,
	property_id,
	children,
	mode,
	commonProperty = true,
}) => {
	const { theme } = useTheme();

	return (
		<Modal
			visible={visible}
			footer={null}
			onCancel={onCancel}
			width={width}
			className={"similar-modal"}>
			<FullScreen className="similar-modal-container">
				<Row
					justify={"center"}
					align={"middle"}
					gutter={[0, theme.spacing.mdSpacing]}
					className="similar-modal-content">
					<Col span={24}>{children}</Col>

				</Row>
			</FullScreen>
		</Modal>
	);
};
